module.exports = __webpack_public_path__ + "img/CM-JRF-25-GMC-Playful.44b74d74.jpg";